import axios from 'axios';
import ApiLogger from './ApiLogger.js';
import {suppressAuthStatusForRequest} from '../auth/authStatus.js';

export { suppressAuthStatusForRequest };

function buildAxiosConfig(options = {}, config = {}) {
    return {
        ...config,
        ...(options.suppressAuthStatus ? { skipAuthStatusHandling: true } : {}),
    };
}

function handleError(responseObject, failureFunction) {
    failureFunction(responseObject);
}

export default {

    getWithParams: function (url, params, options = {}) {
        return new Promise((success, failure) => {
            axios.get(url, buildAxiosConfig(options, { params: params }))
                .then(function (response) {
                    ApiLogger.success("GET", url, response.data);
                    success(response);
                })
                .catch(function (response) {
                    ApiLogger.error("GET", url, response);
                    handleError(response, failure);
                });
        })
    },

    get: function (url, params, options = {}) { return this.getWithParams(url, params, options) },

    post: function (url, body, options = {}) {
        return new Promise((success, failure) => {
            axios.post(url, body, buildAxiosConfig(options))
                .then(function (response) {
                    ApiLogger.success("POST", url, response.data);
                    success(response);
                })
                .catch(function (response) {
                    ApiLogger.error("POST", url, response);
                    handleError(response, failure);
                });
        })
    },

    postMultipart: function (url, body, options = {}) {
        return new Promise((success, failure) => {
            axios.post(url, body, buildAxiosConfig(options, { headers: { 'Content-Type': 'multipart/form-data' } }))
                .then(function (response) {
                    ApiLogger.success("POST", url, response.data);
                    success(response);
                })
                .catch(function (response) {
                    ApiLogger.error("POST", url, response);
                    handleError(response, failure);
                });
        })
    },

    put: function (url, body, options = {}) {
        return new Promise((success, failure) => {
            axios.put(url, body, buildAxiosConfig(options))
                .then(function (response) {
                    ApiLogger.success("PUT", url, response.data);
                    success(response);
                })
                .catch(function (response) {
                    ApiLogger.error("PUT", url, response);
                    handleError(response, failure);
                });
        })
    },

    patch(url, body, options = {}) {
        return new Promise((success, failure) => {
            axios.patch(url, body, buildAxiosConfig(options))
                .then(response => {
                    ApiLogger.success("PATCH", url, response.data);
                    success(response);
                })
                .catch(response => {
                    ApiLogger.error("PATCH", url, response);
                    handleError(response, failure);
                });
        });
    },

    delete: function (url, body, options = {}) {
        return new Promise((success, failure) => {
            axios(buildAxiosConfig(options, {method: 'delete', url: url, data: body}))
            //axios.delete(url, {params: body})
                .then(function (response) {
                    ApiLogger.success("DELETE", url, response.data);
                    success(response);
                })
                .catch(function (response) {
                    ApiLogger.error("DELETE", url, response);
                    handleError(response, failure);
                });
        })
    },

    download: function (url, options = {}) {
        return new Promise((success, failure) => {
            axios.get(url, buildAxiosConfig(options, { responseType: 'blob' }))
                .then(function (response) {
                    ApiLogger.success("GET", url, "[download]");
                    success(response);
                })
                .catch(function (response) {
                    ApiLogger.error("GET", url, response);
                    handleError(response, failure);
                });
        })
    },

    downloadPdf: function (url, body, options = {}) {
        return new Promise((success, failure) => {
            axios.post(url, body, buildAxiosConfig(options, {responseType: 'arraybuffer'}))
                .then(function (response) {
                    ApiLogger.success("POST", url, response.data);
                    success(response);
                })
                .catch(function (response) {
                    ApiLogger.error("POST", url, response);
                    handleError(response, failure);
                });
        });
    }
}
